import { css, Theme } from 'wiloke-react-core';

export const highlight = ({ colors }: Theme) => css`
  color: ${colors.primary};
`;
